/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const REMOVE_GRID_ITEMS = 'REMOVE_GRID_ITEMS';
export const SET_GRID_COLUMN_LIMIT = 'SET_GRID_COLUMN_LIMIT';
export const SET_GRID_ITEM_FOCUS = 'SET_GRID_ITEM_FOCUS';
export const SET_GRID_ITEMS = 'SET_GRID_ITEMS';
export const SET_GRID_ROW_LIMIT = 'SET_GRID_ROW_LIMIT';
export const SET_GRID_FOCUS = 'SET_GRID_FOCUS';
